import { useMutation, useQueryClient } from '@tanstack/react-query';
import { refreshAccountCrmContract, type RefreshAccountCrmResponse } from '@bliks-io/contracts';
import { apiClient } from '@/api/client';

/**
 * Die Stammdaten dieses Kontos jetzt aus dem CRM lesen (LIC-26/LIC-29).
 *
 * Es gibt fünf Momente, an denen das ohnehin geschieht. Dieser ist der
 * sechste: jemand sieht auf die Kontoseite und zweifelt am Stand. Die
 * Kontaktrollen fallen sonst ganz durch — eine geänderte Kontaktzuordnung
 * ändert die *Firma* nicht, und der Zuruf des CRM bleibt aus.
 */
export function useRefreshAccountCrm(accountId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (): Promise<RefreshAccountCrmResponse> => {
      const { data } = await apiClient.post<RefreshAccountCrmResponse>(
        refreshAccountCrmContract.path.replace(':accountId', encodeURIComponent(accountId))
      );
      return data;
    },
    // Auch wenn nichts kam: der Abgleich schreibt am Konto, und die Seite
    // soll zeigen, was jetzt dort steht statt was sie beim Öffnen sah.
    onSettled: () => queryClient.invalidateQueries()
  });
}
